import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Style the confirm action as destructive (fail color). */
  destructive?: boolean;
}

/**
 * Generic confirm dialog built on CDK dialog + design-system chrome.
 * Open via DialogService.confirm(...).
 */
@Component({
  selector: 'bolt-confirm-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dialog-header">
      <h2>{{ data.title }}</h2>
    </div>
    <div class="dialog-body">
      <p style="color: var(--text-soft); line-height: var(--lh-body);">{{ data.message }}</p>
    </div>
    <div class="dialog-footer">
      <button class="btn btn-ghost" (click)="ref.close(false)">
        {{ data.cancelLabel ?? 'Cancel' }}
      </button>
      <button
        class="btn"
        [class.btn-fail]="data.destructive"
        [class.btn-primary]="!data.destructive"
        (click)="ref.close(true)"
      >
        {{ data.confirmLabel ?? 'Confirm' }}
      </button>
    </div>
  `,
})
export class ConfirmDialogComponent {
  readonly ref = inject<DialogRef<boolean, ConfirmDialogComponent>>(DialogRef);
  readonly data = inject<ConfirmDialogData>(DIALOG_DATA);
}
